(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('ss-actividad', {
            parent: 'entity',
            url: '/ss-actividad',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'SSActividads'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/s-s-actividad/s-s-actividads.html',
                    controller: 'SSActividadController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
            }
        })
        .state('ss-actividad-detail', {
            parent: 'ss-actividad',
            url: '/ss-actividad/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'SSActividad'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/s-s-actividad/ss-actividad-detail.html',
                    controller: 'SSActividadDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'SSActividad', function($stateParams, SSActividad) {
                    return SSActividad.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'ss-actividad',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('ss-actividad-detail.edit', {
            parent: 'ss-actividad-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/s-s-actividad/ss-actividad-dialog.html',
                    controller: 'SSActividadDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['SSActividad', function(SSActividad) {
                            return SSActividad.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('ss-actividad.new', {
            parent: 'ss-actividad',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/s-s-actividad/ss-actividad-dialog.html',
                    controller: 'SSActividadDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                nombre: null,
                                descripcion: null,
                                altaReg: null,
                                bajaReg: null,
                                ultActReg: null,
                                activo: null,
                                usuarioUltAct: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('ss-actividad', null, { reload: 'ss-actividad' });
                }, function() {
                    $state.go('ss-actividad');
                });
            }]
        })
        .state('ss-actividad.edit', {
            parent: 'ss-actividad',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/s-s-actividad/ss-actividad-dialog.html',
                    controller: 'SSActividadDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['SSActividad', function(SSActividad) {
                            return SSActividad.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('ss-actividad', null, { reload: 'ss-actividad' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('ss-actividad.delete', {
            parent: 'ss-actividad',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/s-s-actividad/ss-actividad-delete-dialog.html',
                    controller: 'SSActividadDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['SSActividad', function(SSActividad) {
                            return SSActividad.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('ss-actividad', null, { reload: 'ss-actividad' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
